import _ from 'underscore';

app.FulfillmentStationsView = app.AccordionFieldView.extend({
  className() {
    return `${app.AccordionFieldView.prototype.className.apply(this)} virtual-sub-group-panel`;
  },

  initialize(options) {
    _.extend(options || {}, {
      newValue() {
        return {
          name: '',
          isEnabled: true,
        };
      },
      // Provide the method for determining the title of the cell.
      getTitle(fieldGroupView) {
        const fields = fieldGroupView.getValue();
        return fields?.name;
      },
      templateData: {
        title: 'Fullfillment Stations',
        buttonText: 'New Station',
        emptyText: 'No stations yet',
      },
    });

    app.AccordionFieldView.prototype.initialize.apply(this, arguments);
  },
});
